<template>
  <div class="jin-notice" ref="notice" v-if="liveInfo && (liveInfo.roomID !== 33 || hasBuyDing)">
    <div class="jin-notice__list">
      <div
        class="jin-notice__item"
        v-for="(item, index) in notice.list"
        :key="index"
      >
        <div class="jin-notice__wrap">
          <h3>{{ item.title }}</h3>
          <p v-html="item.content"></p>
        </div>
      </div>
    </div>
    <div class="jin-notice__ad">
      <div class="jin-notice__wrap">
        <h3>{{ notice.infoTitle }}</h3>
        <div
          class="jin-notice__contact"
          v-for="(item, index) in notice.infoList"
          :key="index"
        >
          <img v-if="item.qrcode" :src="item.qrcode" :style="item.style"/>
          <p>
            <span>{{ item.title }}</span>
            <span>{{ item.number }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable  */

import {mapGetters, mapState} from 'vuex';

export default {
  name: '',
  computed: {
    ...mapGetters(['liveInfo']),
    ...mapState(['hasBuyDing']),
    notice() {
      return this.liveInfo.notice || {};
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
  mounted() {
    let me = this;
    this.$nextTick(() => {
      console.log('storeOffsetHeight');
      if (
        me.$parent &&
        me.$parent.$parent &&
        me.$parent.$parent.$parent.$parent &&
        me.$parent.$parent.$parent.$parent.$refs &&
        me.$parent.$parent.$parent.$parent.$refs.iScroll &&
        me.$parent.$parent.$parent.$parent.$refs.iScroll.refresh
      ) {
        let storeOffsetHeight = 0;

        let hd = setInterval(() => {
          let offsetHeight = this.$refs.notice ? this.$refs.notice.offsetHeight : 0;
          if (storeOffsetHeight != offsetHeight) {
            storeOffsetHeight = offsetHeight;
            me.$parent.$parent.$parent.$parent.$refs.iScroll.refresh();
          }
        }, 1000);
        setTimeout(() => {
          clearInterval(hd);
        }, 12000);
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// notice.vue?7451d2de